<template>
 <div class="input__container">
    <div class="input__group groupA" @click="addComponents" >
        <button class="innerBtn addParagraph" id="paragraph">+ Paragraph</button>
        <button class="innerBtn addImage" id="image">+ Image</button>
        <button class="innerBtn addList" id="list">+ Unorder List</button>
         <button class="innerBtn addList" id="orderList">+ Order List</button>
        <button class="innerBtn addLineBreak" id="break">+ Line Break</button>
    </div>
  <section v-for="(block, index) in popStore" :key="block.id" class="modalContainer" :data-label="block.type">
      <component 
      :is="block.template"
      :popStoreId="block.id"
      :index="index"
      >
      </component>
     
  </section>
 </div>
</template>

<script setup>
import {popStore} from '@/helper/popStore'
import {template} from '@/helper/popValue'
import { nanoid } from 'nanoid'

const addComponents = (e) => {
  if(!(e.target.closest('.innerBtn'))) return

  const id = nanoid(10)
  for(let i=0; i< template.length; i++){
    if(template[i].type === e.target.closest('.innerBtn').id){
      popStore.value.push({...template[i],id})
    }
  }
}
</script>

<style>

</style>